import gql from 'graphql-tag';
import { map, cloneDeep, omit } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_ITEM_PURCHASE_THREAD = gql`mutation UPDATE_ITEM_PURCHASE_THREAD($id: uuid!, $data: item_purchase_thread_set_input!){
    update_item_purchase_thread(where: { id: { _eq: $id } }, _set: $data) {
        affected_rows
        returning {
            id
        }
    }
}`;

export const UPDATE_ITEM_PURCHASE_THREAD_RESPONSE_MUTATION = (response, items) => {
  const variablesObject = {};
  let variablesText = '';
  let responseQuery = '';
  let itemsQueryMap = [];

  if (response) {
    variablesText += '$id: uuid!, $response_data: information_response_set_input!';
    variablesObject.id = response.id;
    variablesObject.response_data = omit(cloneDeep(response), ['id']);

    responseQuery = `update_information_response(where: { id: {_eq: $id }}, _set: $response_data) {
        affected_rows
        returning {
          id
          updated_at
        }
    }`;
  }

  if (items && items.length) {
    itemsQueryMap = map(items, (item, index) => {
      const itemData = omit(item, ['id']);
      const itemIdPropName = `response_item_id_${index}`;
      const itemDataPropName = `response_item_data_${index}`;

      variablesText += ` ,$${itemIdPropName}: uuid!, $${itemDataPropName}: information_response_item_set_input!`;
      variablesObject[itemIdPropName] = item.id;
      variablesObject[itemDataPropName] = itemData;

      return `update_information_response_item_${index}:update_information_response_item(where: { id: { _eq: $${itemIdPropName} } } _set: $${itemDataPropName} ) {
        affected_rows
        returning {
          id
        }
      }`;
    });
  }

  const mutation = gql(`mutation UPDATE_ITEM_PURCHASE_THREAD(${variablesText}) {
    ${responseQuery && responseQuery.length ? responseQuery : ''},
    ${itemsQueryMap && itemsQueryMap.length ? itemsQueryMap.join('') : ''}
  }`);

  return {
    mutation,
    variables: variablesObject,
  };
};

export const INITIALIZE_ITEM_PURCHASE_THREAD_RESPONSE_MUTATION = gql`
  mutation
  (
    $id: uuid!,
    $readed_at: timestamptz!
  ) {
    update_information_response(where:{id: { _eq: $id }}, _set: {
      readed_at: $readed_at
    }) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const SEND_ITEM_PURCHASE_THREAD_RESPONSE_MUTATION = gql`mutation SEND_ITEM_PURCHASE_THREAD_RESPONSE_MUTATION (
    $id: uuid!,
    $answered_at: timestamptz!
  ){
    update_information_response(where:{id: { _eq: $id }}, _set: {
      answered_at: $answered_at
    }) {
      affected_rows
      returning {
        id
      }
    }
}`;




// WEBPACK FOOTER //
// ./src/store/graphql/mutations/request-information.js